import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import { AllDeployedTransactionContainerData } from "../../../Apis/TransferStationReport/deployedTransactionContainerReportApi";
import TableComponent from "../../../Common/TableComponent/tableComponent";
import ExcelJS from "exceljs";
import isGHMC, { getCurrentDateTime1, getToken } from "../../../Common/helper/helpar";
import { TableLoader } from "../../../Common/ShimmerLoader";
import { exportToPDF } from "../../../../utils/exportToPDF";
import SmallLoader from "../../../../Hooks/SmallLoader";
import { API_BASE_URL1 } from "../../../Services/baseApiUrl";
import axiosInstance from "../../../../Hooks/axoisInstance";

const DeployedContainerTransaction = ({ t }) => {
  const headers = [
    "containerUid",
    "tsincharge",
    "transferStation",
    "containerCode",
    "deploymentDate",
    "latitude",
    "longitude",
    "address",
    "image",
  ];

  const [getAllTripsTonnage, setAllTripsTonnage] = useState([]);
  const [startDate, setStartDate] = useState(getStartOfCurrentDate());
  const [endDate, setEndDate] = useState(getCurrentDateTime());
  const [isLoading, setIsLoading] = useState(false);
  const [IsExcelDowanload, setIsExcelDowanload] = useState(false);
  const isProd = isGHMC();

  useEffect(() => {
    fetchTripsTonnageData(startDate, endDate);
  }, []);

  const fetchTripsTonnageData = async (startDate, endDate) => {
    try {
      setIsLoading(true);
      const response = await AllDeployedTransactionContainerData(
        startDate,
        endDate,
      );
      const formattedData = response.data.map((item) => ({
        ...item,
        containerUid: item.containerUuid || "N/A",
        image: item.containerImageUrl || "N/A",
        transferStation: item.transferStationName || "N/A",
        containerCode: item.containerCode || "N/A",
        tsincharge: item.transferStationInchargeName || "N/A",
        latitude: item.scannedLatitude || "N/A",
        longitude: item.scannedLongitude || "N/A",
        address: item.address || "N/A",
      }));
      setAllTripsTonnage(formattedData);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    fetchTripsTonnageData(startDate, endDate);
  };

  // Function to format dates for display
  const formatDateForDisplay = (dateString) => {
    const date = new Date(dateString);
    const options = {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    };
    return date.toLocaleString("en-GB", options).replace(",", "");
  };

  const options = { day: "numeric", month: "numeric", year: "numeric" };
  const generationTime = ` ${new Date().toLocaleString("en-GB", options).replace(/\//g, "/")}`;
  const downloadAsExcel = async () => {
    const currentDate = new Date();
    const formattedDate = `${currentDate.getDate()}-${currentDate.getMonth() + 1}-${currentDate.getFullYear()}`;
    const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;
    const cumulativeHeadingReport = `Deployed Container Transaction  ${formatDateForDisplay(startDate)} to ${formatDateForDisplay(endDate)} - (at ${getCurrentDateTime1()})`;
    const downloadDateTime = `Report on: ${generationTime}, ${formattedTime}`;
    const dateRange = `Date Range: ${formatDateForDisplay(startDate)} to ${formatDateForDisplay(endDate)}`;

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Zones");
    const boldFont = { bold: true };

    // Add Report Generation Date
    worksheet.addRow(["", "", downloadDateTime, ""]);
    worksheet.mergeCells(1, 2, 1, 8);
    worksheet.getCell(1, 2).value = downloadDateTime;
    worksheet.getCell(1, 2).font = boldFont;
    worksheet.getCell(1, 2).alignment = { horizontal: "center" };

    for (let col = 2; col <= 8; col++) {
      worksheet.getCell(1, col).font = boldFont;
      worksheet.getCell(1, col).alignment = { horizontal: "center" };
    }

    // // Add Date Range
    // worksheet.addRow(["", "", dateRange, ""]);
    // worksheet.mergeCells(2, 2, 2, 8);
    // worksheet.getCell(2, 2).value = dateRange;
    // worksheet.getCell(2, 2).font = boldFont;
    // worksheet.getCell(2, 2).alignment = { horizontal: "center" };

    for (let col = 2; col <= 8; col++) {
      worksheet.getCell(2, col).font = boldFont;
      worksheet.getCell(2, col).alignment = { horizontal: "center" };
    }

    // Add Report Title
    worksheet.addRow(["", "", cumulativeHeadingReport, ""]);
    worksheet.mergeCells(3, 2, 3, 8);
    worksheet.getCell(3, 2).value = cumulativeHeadingReport;
    worksheet.getCell(3, 2).font = boldFont;
    worksheet.getCell(3, 2).alignment = { horizontal: "center" };

    for (let col = 2; col <= 8; col++) {
      worksheet.getCell(3, col).font = boldFont;
      worksheet.getCell(3, col).alignment = { horizontal: "center" };
    }

    // Add empty row for spacing
    worksheet.addRow([""]);

    // Add table header row with bold font
    const tableHeaderRow = worksheet.addRow([
      "S.No",
      "Container UID",
      "TS Incharge",
      "Transfer Station",
      "Container Code",
      "Deployment Date",
      "Latitude",
      "Longitude",
      "Address",
    ]);

    tableHeaderRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
      cell.font = boldFont;
      cell.alignment = { horizontal: "left" };
      if (colNumber >= 1 && colNumber <= 9) {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "F6B1B1" },
        };
      }
    });

    // Add data rows
    getAllTripsTonnage.forEach((item, index) => {
      worksheet
        .addRow([
          index + 1,
          item.containerUuid ?? "N/A",
          item.transferStationInchargeName ?? "N/A",
          item.transferStationName ?? "N/A",
          item.containerCode ?? "N/A",
          item.deploymentDate ?? "N/A",
          item.scannedLatitude ?? "N/A",
          item.scannedLongitude ?? "N/A",
          item.address ?? "N/A",
        ])
        .eachCell({ includeEmpty: true }, (cell, colNumber) => {
          if (colNumber >= 1 && colNumber <= 9) {
            cell.alignment = {
              horizontal: "left",
              vertical: "middle",
              wrapText: true,
            };
          } else {
            cell.alignment = {
              horizontal: "center",
              vertical: "middle",
              wrapText: true,
            };
          }
        });
    });

    // Set column widths dynamically based on content
    worksheet.columns = [
      { width: 5 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 100 },
    ];

    // Save the workbook to a file
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "DeployedContainerTransactionReport.xlsx";
    a.click();
    URL.revokeObjectURL(url);
  };

  const dowanloadExcel = async () => {
    setIsExcelDowanload(true);
    try {
      const response = await axiosInstance.get(
        `${API_BASE_URL1}RawReport/GetAllDeployedContainersTransactionExcelSheet`,
        {
          params: {
            startDate,
            endDate,
          },
          headers: {
            Authorization: `Bearer ${getToken()}`,
          },
          responseType: "blob", // 🔥 VERY IMPORTANT
        },
      );

      // ✅ Create downloadable file
      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = "Deployed Container Transaction.xlsx"; // or backend filename
      document.body.appendChild(link);
      link.click();

      // Cleanup
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Excel download failed", error);
    } finally {
      setIsExcelDowanload(false);
    }
  };
  const exportPdf = async () => {
    await exportToPDF({
      fileName: "Deployed_Container_Transaction_Report",
      title: "Deployed Container Transaction",
      generatedOnText: `Report on: ${generationTime}, ${getCurrentDateTime1()}`,
      data: getAllTripsTonnage,
      landscape: true,

      columns: [
        {
          header: "S.No",
          accessor: (_row, index) => index + 1,
          width: 10,
        },
        {
          header: "Container UID",
          accessor: (row) => row.containerUuid ?? "N/A",
          width: 30,
        },
        {
          header: "TS Incharge",
          accessor: (row) => row.transferStationInchargeName ?? "N/A",
          width: 30,
        },
        {
          header: "Transfer Station",
          accessor: (row) => row.transferStationName ?? "N/A",
          width: 30,
        },
        {
          header: "Container Code",
          accessor: (row) => row.containerCode ?? "N/A",
          width: 25,
        },
        {
          header: "Deployment Date",
          accessor: (row) => formatDateForDisplay(row.deploymentDate) ?? "N/A",
          width: 28,
        },
        {
          header: "Latitude",
          accessor: (row) => row.scannedLatitude ?? "N/A",
          width: 22,
        },
        {
          header: "Longitude",
          accessor: (row) => row.scannedLongitude ?? "N/A",
          width: 22,
        },
        {
          header: "Address",
          accessor: (row) => row.address ?? "N/A",
          width: 60,
        },
        {
          header: " Image",
          accessor: (r) => r.containerImageUrl,
          isImage: true,
          width: 20,
        },
      ],
    });
  };
  return (
    <>
      {isLoading ? (
        <TableLoader height={500} />
      ) : (
        <div style={{ width: "100%" }}>
          <div className="content">
            <div className="page-content">
              <h4 className="text-start mb-3">
                {t("Deployed Container Transaction")} (
                {formatDateForDisplay(startDate)} to{" "}
                {formatDateForDisplay(endDate)}) - (at {getCurrentDateTime1()})
              </h4>
              <div className="card">
                <div className="card-body p-3">
                  <div className="row align-items-end">
                    {/* Date filters */}
                    <div className="col-md-8">
                      <form onSubmit={handleFormSubmit}>
                        <div className="row text-start">
                          <div className="col-md-4">
                            <label>From Date & Time:</label>
                            <input
                              type="datetime-local"
                              name="FromDate"
                              style={inputStyle}
                              value={startDate}
                              className="form-control"
                              max={endDate ? endDate : getCurrentDateTime()}
                              onChange={(e) => setStartDate(e.target.value)}
                            />
                          </div>

                          <div className="col-md-4">
                            <label>To Date & Time:</label>
                            <input
                              type="datetime-local"
                              name="ToDate"
                              style={inputStyle}
                              value={endDate}
                              className="form-control"
                              min={startDate}
                              max={getCurrentDateTime()}
                              onChange={(e) => setEndDate(e.target.value)}
                            />
                          </div>

                          <div className="col-md-2 d-flex">
                            <button
                              type="submit"
                              className={`btn mt-4 w-100 ${isProd ? "search-ghmc" : "search-swm"
                                }`}
                            >
                              Search
                            </button>
                          </div>
                        </div>
                      </form>
                    </div>

                    {/* Export buttons */}
                    <div className="col-md-2 d-flex justify-content-end gap-2">
                      <button
                        className="btn btn-excel ms-auto mt-4"
                        onClick={dowanloadExcel}
                      >
                        {IsExcelDowanload ? <SmallLoader /> : <span>
                          <i className="fa-solid fa-file-excel me-1 icon-container"></i>
                          Excel
                        </span>}
                      </button>


                      <button
                        className="btn btn-excel mt-4"
                        onClick={exportPdf}
                      >
                        <i className="fa-solid fa-file-pdf me-1"></i> Pdf
                      </button>
                    </div>
                  </div>

                  <div className="mt-3">
                    <TableComponent isLoading={isLoading}
                      DataFetchURL={getAllTripsTonnage}
                      headers={headers}
                      imgField="image"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

// Function to get the start of the current date (00:00 AM)
const getStartOfCurrentDate = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}T00:00`;
};

// Function to get current date and time in the required format
const getCurrentDateTime = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  const hour = String(now.getHours()).padStart(2, "0");
  const minute = String(now.getMinutes()).padStart(2, "0");
  return `${year}-${month}-${day}T${hour}:${minute}`;
};

// Styles for input and button
const inputStyle = {
  border: "1px solid #E2E2E2",
  padding: "15px",
};

const buttonStyle = {
  border: "1px solid #E2E2E2",
  borderRadius: "5px",
  color: "#fff",
};

export default withTranslation()(DeployedContainerTransaction);
